import { createStyles } from '@material-ui/core/styles';

export const recallQuoteStyles = createStyles({
    recallQuoteContainer: {
        maxWidth: '100%',
        height: 486,
        display: 'flex',
        flexDirection: 'column',
    },
    recallQuoteToogleContaner: {
        'display': 'flex',
        'flexDirection': 'column',
        'backgroundColor': '#dddddd',
        'bottom': 0,
        'position': 'sticky',
        'width': '100%',
        'height': '96px',
        '& label': {
            marginLeft: '16px',
        }
    },
    grid: {
        'maxWidth': '100% !important',
        'height': 335,
        '& .dx-datagrid-rowsview .dx-selection.dx-row:not(.dx-row-focused) > td.dx-focused': {
            background: '#e6e6e6 !important'
        },
        '& .dx-datagrid .dx-datagrid-headers.dx-state-focused .dx-header-row td:focus': {
          outline: 'unset'
        },
        '& .dx-datagrid-focus-overlay': {
          border: 'none',
        },
    }
});

export const toggleStyles = createStyles({
    switchBase: {
        '&$checked': {
            '& + $bar': {
                backgroundColor: '#6DD900',
                opacity: 1
            },
        },
    },
    bar: {},
    checked: {},
    formControlLabel: {
        '&$disabled': {
            color: '#555555',
        },
    },
    disabled: {

    },
});
